import { useDroppable } from '@dnd-kit/core';
import { StyledAnswerDroppable } from './AnswerDroppable.styled';
import DraggableOption from '../DraggableOption/DraggableOption';
import Image from 'next/image';

export default function AnswerDroppable({ questionId, answer, disabled }) {
  const { setNodeRef } = useDroppable({
    id: questionId,
  });

  return (
    <StyledAnswerDroppable
      ref={setNodeRef}
      className={`${answer ? '' : 'empty'} ${disabled ? 'disabled' : ''}`}
      disabled
    >
      {answer ? (
        <DraggableOption
          key={answer.id}
          option={answer}
          answered
          disabled={disabled}
        />
      ) : (
        <>
          <Image
            src={
              process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
              '/commonGameAssets/realTime/drag-here-placeholder.png'
            }
            alt=""
            width={700}
            height={394}
            objectFit="contain"
          />
          <span className="drag-text">Drag here</span>
        </>
      )}
    </StyledAnswerDroppable>
  );
}
